import _sfc_main$1 from "./wrapper/TabsWrapper.js";
import _sfc_main from "./wrapper/TabsWrapperItem.js";
import { default as default2 } from "./core/Tabs.js";
import { default as default3 } from "./core/TabsContent.js";
import { default as default4 } from "./core/TabsList.js";
import { default as default5 } from "./core/TabsTrigger.js";
_sfc_main$1.Item = _sfc_main;
const TabsWrapper = _sfc_main$1;
export {
  default2 as Tabs,
  default3 as TabsContent,
  default4 as TabsList,
  default5 as TabsTrigger,
  TabsWrapper,
  _sfc_main as TabsWrapperItem
};
//# sourceMappingURL=index.js.map
